export const isPublicSearchText = (value: string, multiline = false) =>
  Array.from(value).every((character) => {
    const point = character.codePointAt(0)!;
    return (
      (multiline && [9, 10, 13].includes(point)) ||
      (point > 31 &&
        (point < 127 || point > 159) &&
        (point < 0xd800 || point > 0xdfff))
    );
  });
const whitespace = (point: number) =>
  (point >= 9 && point <= 13) ||
  (point >= 28 && point <= 32) ||
  point === 0x1680 ||
  (point >= 0x2000 && point <= 0x2006) ||
  (point >= 0x2008 && point <= 0x200a) ||
  [0x2028, 0x2029, 0x205f, 0x3000].includes(point);
export function stripPublicSearchText(value: string) {
  let start = 0;
  let end = value.length;
  while (start < end && whitespace(value.charCodeAt(start))) start++;
  while (end > start && whitespace(value.charCodeAt(end - 1))) end--;
  return value.slice(start, end);
}

/** Same raw/normalized UTF-16 bound and whitespace as the public API. */
export function normalizePublicSearchQuery(value: string) {
  if (
    typeof value !== 'string' ||
    value.length > 120 ||
    !isPublicSearchText(value)
  )
    throw new Error('INVALID_PUBLIC_SEARCH');
  const q = stripPublicSearchText(value.normalize('NFKC'));
  if (!q || q.length > 120 || !isPublicSearchText(q))
    throw new Error('INVALID_PUBLIC_SEARCH');
  return q;
}
